import { Textarea } from "@/components/ui/textarea";

interface AdditionalContextInputProps {
  additionalContext: string | undefined;
  setAdditionalContext: (value: string | undefined) => void;
  disabled?: boolean;
}

export function AdditionalContextInput({
  additionalContext,
  setAdditionalContext,
  disabled = false,
}: AdditionalContextInputProps) {
  return (
    <div>
      <Textarea
        value={additionalContext || ""}
        onChange={(e) =>
          setAdditionalContext(
            e.target.value.trim() === "" ? undefined : e.target.value,
          )
        }
        placeholder="Examples: information about additional resources to be included (companies, documents, etc), external information that can be relevant (news, internal documents) or just additional guidelines for playbook execution."
        className="min-h-[120px] resize-none"
        disabled={disabled}
      />
    </div>
  );
}
